import EditOrderContainer from './edit-order-container';

export default EditOrderContainer;
